import React, { useContext } from 'react';

import { Container } from 'components/common';
import { LangContext } from 'providers/LangProvider';
import { Box, Wrapper } from './styles';

// The name is inflected in Icelandic ("hjá Selasetri Íslands")
const selasetur = name => (
  <a href="https://selasetur.is" rel="noopener noreferrer" target="_blank">
    {name}
  </a>
);

// The closure is the most practical thing on the site for visitors, so it comes right after the photo
export const Notice = () => {
  const { lang } = useContext(LangContext);

  return (
    <Wrapper as={Container}>
      <Box role="note">
        {lang === 'is' ? (
          <>
            <p>
              <strong>Hindisvík er lokuð ferðamönnum.</strong>
            </p>
            <p>
              Jörðin er náttúruverndarjörð og lokuð fyrir allri umferð ferðamanna og annarra óviðkomandi, meðal annars
              til að vernda seli, dýralíf og viðkvæman gróður. Vinsamlegast virðið lokunina.
            </p>
            <p>
              Upplýsingar um hvar hægt er að skoða seli á Vatnsnesi fást hjá {selasetur('Selasetri Íslands')} á
              Hvammstanga.
            </p>
          </>
        ) : (
          <>
            <p>
              <strong>Hindisvík is closed to visitors.</strong>
            </p>
            <p>
              The land is a nature preserve and closed to tourists and all other unauthorised traffic, to protect the
              seal colony, wildlife and delicate vegetation. Please respect the closure.
            </p>
            <p>
              For places on Vatnsnes where you can see seals, ask {selasetur('Selasetur Íslands')} (The Icelandic Seal
              Center) in Hvammstangi.
            </p>
          </>
        )}
      </Box>
    </Wrapper>
  );
};
